import { ArrowBack } from 'react-ionicons';

const AccessBackButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      className="flex items-center gap-2 text-xs font-bold text-content-base-subdued hover:text-accent-blue"
      onClick={onClick}
    >
      <ArrowBack color="currentColor" width="18px" height="18px" />
      Back
    </button>
  );
};

export default AccessBackButton;
